import { AddRMAStatusResultModel, GetRMAStatusParamater, updateRMAStatus } from "@NA/Services/ADIRMAStatusService";

import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import {
    HasOnError,
    HasOnSuccess,
    createHandlerChainRunnerOptionalParameter,
} from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomApiHandler<GetRMAStatusParamater & HasOnSuccess & HasOnError, AddRMAStatusResultModel>;

export const leadingZero = (value: number) => {
    if (value < 10) {
        return `0${value.toString()}`;
    }
    return value.toString();
};

export const DefaultDate = (from: boolean, clear: boolean, numDays: 30) => {
    let now = new Date();
    let today = new Date();
    let toDate = new Date();
    now.setTime(now.getTime() - numDays * 24 * 60 * 60 * 1000);
    if (!clear && from) {
        return `${now.getFullYear()}/${leadingZero(now.getMonth() + 1)}/${leadingZero(now.getDate())}`;
    } if (clear && from) {
        return `${leadingZero(now.getDate())}/${leadingZero(now.getMonth() + 1)}/${now.getFullYear()}`;
    } if (clear && !from) {
        return `${leadingZero(today.getDate())}/${leadingZero(today.getMonth() + 1)}/${today.getFullYear()}`;
    } if (!clear && !from) {
        return `${toDate.getFullYear()}/${leadingZero(toDate.getMonth() + 1)}/${leadingZero(toDate.getDate())}`;
    }
};

// DefaultDate(from, clear) {
//     var now = new Date();
//     var today = new Date();
//     var dayOfTheWeek = now.getDay();
//     var toDate = new Date();
//     now.setTime(now.getTime() - 30 * 24 * 60 * 60 * 1000);
//     if (clear == false && from == true) {
//         return now.getFullYear() + "/" + this.leadingZero((now.getMonth() + 1)) + "/" + this.leadingZero(now.getDate())
//     }
//     else if (clear == true && from == true) {
//         return this.leadingZero(now.getDate()) + "/" + this.leadingZero(now.getMonth() + 1) + "/" + now.getFullYear()
//     }
//     else if (clear == true && from == false) {
//         return this.leadingZero(today.getDate()) + "/" + this.leadingZero(today.getMonth() + 1) + "/" + today.getFullYear()
//     }
//     else if (clear == false && from == false) {
//         return toDate.getFullYear() + "/" + this.leadingZero((toDate.getMonth() + 1)) + "/" + this.leadingZero(toDate.getDate())
//     }
// }

export const rmaStatusParams: GetRMAStatusParamater = {
    orderSearchType: "PO", // This parameter is being used by P21
    // orderSearchType: "All", // Code from Spire Prod
    pO: null, // this is being used in P21
    status: "All",
    toDate: DefaultDate(false, false, 30) || "",
    fromDate: DefaultDate(true, false, 30) || "",
    selectedPage: 1,
    sortBy: "Date_Submitted DESC",
    sortOrder: "null", // Being used in P21
    // sortOrder: "", Code from Prod spire
    currentPageSize: "12",
    properties: [],
};

export const DispatchADIRMAStatus: HandlerType = (props: any) => {
    props.dispatch({
        type: "Custom/LoadRMAStatus",
        result: props.parameter,
    });
};

export const LoadADIRMAStatus: HandlerType = async (props: any) => {
    props.apiResult = await updateRMAStatus(props.parameter);
    props.dispatch({
        type: "Custom/LoadRMAStatusOrder",
        result: props.apiResult,
    });
};

export const DispatchCompleteLoadADIRMAStatus: HandlerType = props => {
    props.dispatch({
        type: "Custom/LoadRMAStatusComplete",
    });
    if (props.apiResult) {
        props.parameter.onSuccess?.(props.apiResult as any);
    } else {
        props.parameter.onError?.(props.apiResult);
    }
};

export const chain = [DispatchADIRMAStatus, LoadADIRMAStatus, DispatchCompleteLoadADIRMAStatus];

const adiRMAStatus = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        ...rmaStatusParams,
        onSuccess: (result: any) => { },
    },
    "RMAStatus",
);
export default adiRMAStatus;
